import { fabric } from 'fabric'

export default {
  isA: function (object) {
    return object.type === 'rect'
  },

  new: function (pointer, fillColour, strokeColour, strokeWidth) {
    return new fabric.Rect({
      left: pointer.x,
      top: pointer.y,
      width: 0,
      height: 0,
      stroke: strokeColour,
      strokeWidth: strokeWidth,
      fill: fillColour
    })
  },

  options: function (shape, pointer, shiftKey) {
    const options = {
      width: Math.abs(pointer.x - shape.left),
      height: Math.abs(pointer.y - shape.top),
      originX: pointer.x >= shape.left ? 'left' : 'right',
      originY: pointer.y >= shape.top ? 'top' : 'bottom'
    }

    // square mode
    if (shiftKey) {
      if (options.height > options.width) {
        options.height = options.width
      } else {
        options.width = options.height
      }
    }

    return options
  },

  scale: function (shape) {
    shape.set({
      width: shape.width * shape.scaleX,
      height: shape.height * shape.scaleY,
      scaleX: 1,
      scaleY: 1
    })
  }
}
